import { SelectedSkuFilters } from "models/inventory/helpers/skuFilters.helpers";
import { types } from "../types/types";

export const setSelectedFilters = (filters: Partial<SelectedSkuFilters>) => ({
  type: types.skusSetSelectedFilter,
  payload: { filters }
});

export const updateSelectedFilters = (key: keyof SelectedSkuFilters, value: any) => ({
  type: types.skusUpdateSelectedFilter,
  payload: { key, value }
});

export const clearSelectedFilters = () => ({
  type: types.skusClearSelectedFilter
});
